export default "__VITE_ASSET__BTvv2OCT__"